// Fallback program codes if environment variable is not set
const FALLBACK_RESTRICTED_PROGRAM_CODES = "QA_TEST_AUTO_REWARDS,BCBSAR-M-2026,BCBSAR-ACA-2026";

// Get restricted program codes from env, or use fallback
// eslint-disable-next-line import/prefer-default-export
export const RESTRICTED_PROGRAM_CODES = (
  process.env.REACT_APP_SELF_SERVE_MOBILE_RESTRICTED_PROGRAM_CODES ||
  FALLBACK_RESTRICTED_PROGRAM_CODES
).split(',').filter(Boolean);
